function DebugRadio({
  label,
  value,
  checked,
  onChange,
}: React.LabelHTMLAttributes<HTMLLabelElement> & {
  label: string;
  value: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}): React.ReactElement {
  return (
    <label className="flex items-center gap-2">
      <input
        type="radio"
        className="border-input text-primary focus:ring-primary h-4 w-4"
        value={value}
        checked={checked}
        onChange={(e) => onChange(e)}
      />
      <span className="text-sm font-medium">{label}</span>
    </label>
  );
}

export function DebugRadioGroup({
  options,
  selectedOption,
  onChange,
}: {
  options: { label: string; value: string }[];
  selectedOption: string;
  onChange: (value: string) => void;
}): React.ReactElement {
  return (
    <div className="flex flex-col gap-2">
      {options.map((option) => (
        <DebugRadio
          key={option.value}
          label={option.label}
          value={option.value}
          checked={selectedOption === option.value}
          onChange={() => onChange(option.value)}
        />
      ))}
    </div>
  );
}
